import { GitBranch, FileText, AlertCircle, Check } from 'lucide-react';
import { useAppSelector } from '@/store/hooks';

export function StatusBar() {
  const isDirty = useAppSelector((state) => state.editor.isDirty);
  const cursorPosition = useAppSelector((state) => state.editor.cursorPosition);
  const selectedFileId = useAppSelector((state) => state.files.selectedFileId);
  const files = useAppSelector((state) => state.files.files);
  const language = useAppSelector((state) => state.editor.language);

  const selectedFile = files.find((f) => f.id === selectedFileId);

  return (
    <footer className="flex h-6 items-center justify-between border-t bg-background px-2 text-xs text-muted-foreground">
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1">
          <GitBranch className="h-3 w-3" />
          <span>main</span>
        </div>

        {selectedFile && (
          <>
            <div className="flex items-center gap-1">
              <FileText className="h-3 w-3" />
              <span>{selectedFile.name}</span>
            </div>

            <div className="flex items-center gap-1">
              {isDirty ? (
                <>
                  <AlertCircle className="h-3 w-3 text-yellow-500" />
                  <span>Modified</span>
                </>
              ) : (
                <>
                  <Check className="h-3 w-3 text-green-500" />
                  <span>Saved</span>
                </>
              )}
            </div>
          </>
        )}
      </div>

      <div className="flex items-center gap-3">
        {selectedFile && (
          <>
            <span>
              Ln {cursorPosition.line}, Col {cursorPosition.column}
            </span>
            <span className="capitalize">{language}</span>
            <span>UTF-8</span>
          </>
        )}
      </div>
    </footer>
  );
}
